import type { LoggerConfigType } from '@/types/LoggerConfigType';
import type { StickyFieldsType } from '@/types/StickyFieldsType';

export const PotaLoggerConfig: LoggerConfigType = {
  templateId: 'POTA',
  templateDescription: 'HAMRS POTA Template',
  toolbarItems: ['TIME', 'FREQUENCY', 'MODE', 'TX_POWER', 'MY_CALLSIGN', 'MY_PARK', 'MY_LOCATION'],
  toolbarPosition: 'TOP',
  panels: ['QSO_MAP', 'POTA_SPOTS'],
  tableColumns: ['qsoDateTime', 'call', 'rstSent', 'rstRcvd', 'state', 'freq', 'band', 'mode', 'potaRef', 'qrzcomQsoUploadStatus'],
  dupeCheckFields: ['call', 'mode', 'band', 'potaRef', 'qsoDate'],
  stickyFields: [
    "freq",
    "band",
    "myPotaRef",
    "myGridsquare",
    "mode",
    "txPwr",
    "myCnty",
    "myState",
    "operator",
    "stationCallsign",
  ] as unknown as StickyFieldsType[],
  fieldRows: [
    {
      columns: { base: 4 },
      fields: [
        { component: 'TheirCall' },
        { component: 'RstSent' },
        { component: 'RstReceived' },
        { component: 'TheirPark' }]
    },
    {
      columns: { base: 2 },
      fields: [
        { component: 'Comments' },
        { component: 'Notes' },
      ]
    },
    {
      fields: [
        { component: 'OperatorBar' }
      ]
    },
    {
      classes: "flex justify-end",
      fields: [
        { component: 'ErrorSummary', props: { classes: 'mr-auto' } },
        { component: 'ClearButton' },
        { component: 'SaveButton' },
      ]
    }
  ],
}

export default PotaLoggerConfig;